export default {
    root: ({ instance }) => {
        const variant = instance.$attrs.variant;
        if (variant === 'secondary') return 'secondary-tablist';
        if (variant === 'tertiary') return 'tertiary-tablist';
        return 'primary-tablist';
    },
    content: ({ instance }) => [
        'w-full',
        {
            'overflow-x-auto': instance.$pcTabs.scrollable,
        },
    ],
    tabs: 'flex',
    inkbar: ({ instance }) => {
        const variant = instance.$attrs.variant;
        if (variant === 'secondary') return 'secondary-tablist-inkbar';
        if (variant === 'tertiary') return 'tertiary-tablist-inkbar';
        return 'primary-tablist-inkbar';
    },
};
